import React, { useState, useEffect } from 'react';
import { motion, MotionProps } from 'framer-motion';
import "./Detail.css";
import { GiCauldron, GiGriffinShield, GiPalette } from "react-icons/gi";

type DeviceType = 'mobile' | 'tablet' | 'desktop';

const useDeviceType = (): DeviceType => {
  const [device, setDevice] = useState<DeviceType>('desktop');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setDevice('mobile');
      } else if (width >= 640 && width < 1024) {
        setDevice('tablet');
      } else {
        setDevice('desktop');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return device;
};

const Detail = () => {
  const device = useDeviceType();

  // Animación fija desde la DERECHA
  const getFadeAnimationRight = (): MotionProps => {
    const distanceMap = {
      mobile: 0,   // Entra por la derecha con 30px de recorrido
      tablet: 60,   // Entra por la derecha con 60px de recorrido
      desktop: 100, // Entra por la derecha con 100px de recorrido
    };

    return {
      initial: { opacity: 0, x: distanceMap[device] },
      whileInView: { opacity: 1, x: 0 },
      viewport: { once: true, margin: "0px" },
      transition: { duration: 0.5, ease: "easeOut", delay: 0.3 },
    };
  };

  // Animación fija desde la IZQUIERDA
  const getFadeAnimationLeft = (): MotionProps => {
    const distanceMap = {
      mobile: 0,   // Entra por la izquierda con -30px de recorrido
      tablet: -60,   // Entra por la izquierda con -60px de recorrido
      desktop: -100, // Entra por la izquierda con -100px de recorrido
    };

    return {
      initial: { opacity: 0, x: distanceMap[device] },
      whileInView: { opacity: 1, x: 0 },
      viewport: { once: true, margin: "0px" },
      transition: { duration: 0.5, ease: "easeOut", delay: 0.3 },
    };
  };

  // Animación fija desde ABAJO
  const getFadeAnimationBottom = (): MotionProps => {
    const distanceMap = {
      mobile: 0,
      tablet: 60,
      desktop: 100,
    };

    return {
      initial: { opacity: 0, y: distanceMap[device] },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true, margin: "0px" },
      transition: { duration: 0.5, ease: "easeOut", delay: 0.3 },
    };
  };

  const getFadeUpAnimation = (index = 0): MotionProps => ({
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "0px" },
    transition: {
      duration: 0.5,
      ease: "easeOut",
      delay: index * 0.3,
    },
  });

  return (
    <div className='detail-section'>
      <div className='detail-title-section'>
        <h2>El Estándar Card Armory</h2>
        <span>Equipamiento de precisión para el aventurero moderno.</span>
      </div>

      <div className='detail-elements-section'>
        <motion.div className='detail-element-item' {...getFadeUpAnimation(1)}>
          <div className='detail-element-icon'><GiCauldron /></div>
          <span className='detail-element-item-title'>Materiales Anti-ácido y Sin PVC</span>
          <span className='detail-element-item-text'>Cero riesgo de daño a largo plazo para tus cartas más valiosas.</span>
        </motion.div>

        <motion.div className='detail-element-item' {...getFadeUpAnimation(2)}>
          <div className='detail-element-icon'><GiGriffinShield /></div>
          <span className='detail-element-item-title'>Blindaje Rígido</span>
          <span className='detail-element-item-text'>Protección contra impactos, doble costura en binders y cierres magnéticos ultra seguros en deck boxes.</span>
        </motion.div>

        <motion.div className='detail-element-item' {...getFadeUpAnimation(3)}>
          <div className='detail-element-icon'><GiPalette /></div>
          <span className='detail-element-item-title'>Diseño Ergonómico</span>
          <span className='detail-element-item-text'>Diseñado tanto para jugadores competitivos como para coleccionistas exigentes.</span>
        </motion.div>
      </div>

      <motion.div className='logo-detail-section-l' {...getFadeAnimationLeft()}>
        <img src='/isologo.png' className='logo-detail-section-img' alt='isologo' />
      </motion.div>

      <motion.div className='logo-detail-section-r' {...getFadeAnimationRight()}>
        <img src='/isologo.png' className='logo-detail-section-img' alt='isologo' />
      </motion.div>

      <motion.div className='logo-detail-section-b' {...getFadeAnimationBottom()}>
        <img src='/isologo.png' className='logo-detail-section-img' alt='isologo' />
      </motion.div>
    </div>
  );
};

export default Detail;